import { Action } from '@/_core/fluxstore/types';
import { StorymapState, SubtaskStatusCategory } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class RemoveEmptyStatus extends Action<StorymapState> {
    public static ACTION_TYPE = 'RemoveEmptyStatus';

    public constructor(public category: SubtaskStatusCategory) {
        super(RemoveEmptyStatus.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: RemoveEmptyStatus): void => {
    state.subtaskStatuses = state.subtaskStatuses.filter(x => x.category != action.category || x.key != null);
};

//@ts-ignore
registerReducer(RemoveEmptyStatus.ACTION_TYPE, reducer);
